import { GQSPayload } from "@p81-common/shell-core-js";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";

export function request(json: GQSPayload) {
  return requestWithSubTenantIfNeeded("post", "generic-query/query", { json });
}